export default __webpack_public_path__ + "static/media/news5.b184c438.png";